export class InputsToUpdate {
    // tslint:disable-next-line: variable-name
    appointment_date: string;
    // tslint:disable-next-line: variable-name
    material_date: string;
    // tslint:disable-next-line: variable-name
    repair_date: string;
    // tslint:disable-next-line: variable-name
    supplier_comment: string;
    // tslint:disable-next-line: variable-name
    operator_num: number;
}
